import { loadTossPayments } from '@tosspayments/payment-sdk';
import apiClient from './axios';
import Store from 'store';
import store from '../store';
import { TossCheckoutPage } from '../components/toss_payment/paymentModal';
import { Fade, Modal } from '@material-ui/core';
import { MediaQuery } from '../components/Common';
import { isMobile } from 'react-device-detect';
import images from '../assets';
import { getTossModalWidh } from './modalWidh';
const axios = require('axios').default;

export const getUuid = async () => {
  let uuid = '';
  let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < 7; i++) uuid += possible.charAt(Math.floor(Math.random() * possible.length));
  return uuid;
};

export const toss_register = async (successUrl, failUrl) => {
  const location = process.env.REACT_APP_LOCATION;
  const clientKey =
    location === 'develop' || store.getState().username === process.env.REACT_APP_MANAGER3
      ? process.env.REACT_APP_TOSS_BILLING_CLIENTKEY_TEST
      : process.env.REACT_APP_TOSS_BILLING_CLIENTKEY;
  const customer_uid = crypto.randomUUID();
  loadTossPayments(clientKey).then((tossPayments) => {
    // ------ 카드 등록창 호출 ------
    tossPayments
      .requestBillingAuth('카드', {
        // 결제수단 파라미터 (자동결제는 카드만 지원합니다.)
        // 결제 정보 파라미터
        // 더 많은 결제 정보 파라미터는 결제창 Javascript SDK에서 확인하세요.
        // https://docs.tosspayments.com/reference/js-sdk#requestbillingauth카드-결제-정보
        customerKey: customer_uid, // 구매자 ID로 상점에서 만들어야 합니다. 빌링키와 매핑됩니다. 자세한 파라미터 설명은 결제 정보 파라미터 설명을 참고하세요.
        successUrl: `${process.env.REACT_APP_FRONT_URL}/${successUrl}`, // 카드 등록에 성공하면 이동하는 페이지(직접 만들어주세요)
        failUrl: `${process.env.REACT_APP_FRONT_URL}/${successUrl}`, // 카드 등록에 실패하면 이동하는 페이지(직접 만들어주세요)
      })
      // ------ 결제창을 띄울 수 없는 에러 처리 ------
      // 메서드 실행에 실패해서 reject 된 에러를 처리하는 블록입니다.
      // 결제창에서 발생할 수 있는 에러를 확인하세요.
      // https://docs.tosspayments.com/reference/error-codes#결제창공통-sdk-에러
      .catch(function (error) {
        console.log('error: ', error);
        if (error.code === 'USER_CANCEL') {
          // 결제 고객이 결제창을 닫았을 때 에러 처리
        }
      });
  });
};

export const toss_getBillingKey = async (customerKey, authKey, callBackFunction) => {
  const isDevMode = process.env.REACT_APP_LOCATION === 'develop';
  const isManager = store.getState().username === process.env.REACT_APP_MANAGER3;

  const secretKey =
    isDevMode || isManager ? process.env.REACT_APP_TOSS_BILLING_SECRET_TEST : process.env.REACT_APP_TOSS_BILLING_SECRET;

  const encryptedSecretKey = `Basic ${Buffer.from(`${secretKey}:`).toString('base64')}`;

  const options = {
    method: 'POST',
    url: process.env.REACT_APP_TOSS_BILLING_PAY_URL,
    headers: {
      Authorization: encryptedSecretKey,
      'Content-Type': 'application/json',
    },
    data: {
      authKey: authKey,
      customerKey: customerKey,
    },
  };

  try {
    const response = await axios.request(options);
    console.log('response:', response);
    const merchant_uid = crypto.randomUUID();

    await callBackFunction(customerKey, authKey, response, merchant_uid);
  } catch (error) {
    console.log('error: ', error);
    alert(error);
    // await apiClient.post('/web/saveLog', {
    //   where: 'AISubscribe-front-toss_getBillingKey',
    //   log: error,
    // });
    throw new Error(
      error.response
        ? `Error ${error.response.status}: ${error.response.data.message || error.response.statusText}`
        : error.message || 'An unknown error occurred',
    );
  }
};

export const ModalContents = ({ children, style, onClose }) => {
  return (
    <>
      <div style={{ backgroundColor: 'white', borderRadius: 5, position: 'relative', ...style }} id="receipt">
        <MediaQuery min={500}>
          <div>{children}</div>
          <div onClick={onClose} style={{ position: 'absolute', top: 20, right: 20, cursor: 'pointer' }}>
            <img alt="" src={images.icon_close} />
          </div>
        </MediaQuery>
        <MediaQuery max={499}>
          <div>{children}</div>
          <div onClick={onClose} style={{ position: 'absolute', top: 20, right: 20, cursor: 'pointer' }}>
            <img alt="" src={images.icon_close} />
          </div>
        </MediaQuery>
      </div>
    </>
  );
};

export const TossPaymentModal = ({
  show,
  onClose,
  productName,
  payAmount,
  successUrl,
  user_id,
  user_uuid,
  couponSerial,
  isEnterprise = false,
}) => {
  const modalWith = getTossModalWidh();
  const redirectUrl = successUrl + `?couponSerial=${couponSerial}`;

  return (
    <Modal
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
      open={show}
      onClose={onClose}
      disableEnforceFocus={true}
    >
      <Fade in={show}>
        <div
          style={{
            width: modalWith,
            height: 'auto',
            overflowY: isMobile ? 'scroll' : 'hidden', // 모바일일 때만 스크롤 추가
          }}
        >
          <ModalContents onClose={onClose}>
            <TossCheckoutPage
              show={show}
              onClose={onClose}
              productName={productName}
              payAmount={payAmount}
              successUrl={redirectUrl}
              user_id={user_id}
              user_uuid={user_uuid}
              isEnterprise={isEnterprise}
            />
          </ModalContents>
        </div>
      </Fade>
    </Modal>
  );
};
